import {
  faHome,
  faEye,
  faBullseye,
  faExclamationTriangle,
  faChartLine,
  faBarChart,
  faArrowTurnUp,
  faCamera,
  faCircleDollarToSlot,
  faChartColumn,
  faSearch,
  faEnvelope,
  faArrowAltCircleLeft,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MenuItem } from "react-pro-sidebar";
import { Link } from "react-router-dom";
import { TSLandingPage } from "../components/TSLandingPage";
import { CognitoJwtPayload } from "../features/console/consoleSlice";
import { SubdomainOrgIdObject } from "./FunctionsAndInterfaces";
import { AppEmbedWrapper } from "../components/AppEmbed/AppEmbedWrapper";
import { GenericLiveboardEmbed } from "../components/GenericLiveboardEmbed";
import Layout from "../components/Layout";
import SecureRoute from "../components/SecureRoute";
import { DefaultSidebarBreakpoint } from "../components/SidebarToggle";
import { appEmbedWrapperCssRules } from "../cssRules";
import { ContactUs } from "../pages/contactus/ContactUs";
import { CashFlowWalk } from "../pages/demos/rocket-demo/CashFlowWalk";
import { ProfitabilityWalk } from "../pages/demos/rocket-demo/ProfitabilityWalk";
import { RocketBalanceSheet } from "../pages/demos/rocket-demo/RocketBalanceSheet";
import { RocketIncomeStatement } from "../pages/demos/rocket-demo/RocketIncomeStatement";
import { SignOut } from "../pages/sign-out/SignOut";
import { getUserSessionItem } from "..";
import { FinancialModeling } from "../pages/demos/rocket-demo/FinancialModeling";

const orgId: number = 888221964;
const subDomain: string = "rocket";
const nameOfProduct: string = "Rocket";
const secureRouteGroups: string[] = ["enduser"];

export const rocketObject: SubdomainOrgIdObject = {
  orgID: orgId,
  path: subDomain,
};

export const RocketLandingPage = (
  <TSLandingPage
    smallButtons={false}
    parentURL={`/${subDomain}`}
    buttons={[
      [
        {
          title: "CEO Summary",
          description: "",
          link: "ceosummary",
          internal: true,
        },
        {
          title: "CFO Summary",
          description: "",
          link: "cfosummary",
          internal: true,
        },
        {
          title: "Segment Analytics",
          description: "",
          link: "segmentanalytics",
          internal: true,
        },
        {
          title: "Rocket Servicing Overview",
          description: "",
          link: "servicing",
          internal: true,
        },
      ],
      [
        {
          title: "Income Statement",
          description: "",
          link: "incomestatement",
          internal: true,
        },
        {
          title: "Balance Sheet",
          description: "",
          link: "balancesheet",
          internal: true,
        },
        {
          title: "Cash Flow Walk",
          description: "",
          link: "cashflowwalk",
          internal: true,
        },
        {
          title: "Profitability Walk",
          description: "",
          link: "profitabilitywalk",
          internal: true,
        },
      ],
      [
        {
          title: "Search",
          description: "",
          link: "Search",
          internal: true,
        },
        {
          title: "Financial Modeling",
          description: "",
          link: "financialmodeling",
          internal: true,
        },
      ],
    ]}
  />
);

const sidebarMenu = () => {
  /*   let userSession = getUserSessionItem("user")!;
  let user = JSON.parse(userSession) as CognitoJwtPayload; //get user info */
  return (
    <>
      {/*       <>
        {user && user["cognito:groups"]?.includes("Administrator") && (
          <MenuItem>
            <Link to={`${subDomain}/liveboardmanager`}>
              <div className="sidebar-item">
                <FontAwesomeIcon className="me-2" icon={faHome} />
                Liveboard Manager
              </div>
            </Link>
          </MenuItem>
        )}
      </> */}
      <MenuItem>
        <Link to={`${subDomain}/ceosummary`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faEye} />
            CEO Summary
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`${subDomain}/cfosummary`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faBullseye} />
            CFO Summary
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`${subDomain}/servicing`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faExclamationTriangle} />
            Servicing Overview
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`${subDomain}/segmentanalytics`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faChartLine} />
            Segment Analytics
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`${subDomain}/financialmodeling`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faBarChart} />
            Financial Modeling
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`${subDomain}/incomestatement`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faArrowTurnUp} />
            Income Statement
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`${subDomain}/balancesheet`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faCamera} />
            Balance Sheet
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`${subDomain}/cashflowwalk`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faCircleDollarToSlot} />
            Cash Flow Walk
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`${subDomain}/profitabilitywalk`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faChartColumn} />
            Profitability Walk
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`${subDomain}/search`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faSearch} />
            Search
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`${subDomain}/contactus`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faEnvelope} />
            Contact Us
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`${subDomain}/signout`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faArrowAltCircleLeft} />
            Log Out
          </div>
        </Link>
      </MenuItem>
    </>
  );
};
export const rocketRoutes = {
  element: (
    <Layout
      breakPoint={DefaultSidebarBreakpoint}
      smallHeader={true}
      sidebarMenu={sidebarMenu()}
      contactUsPath={`/${subDomain}/contactus`}
      signOutPath={`/${subDomain}/signout`}
    />
  ),
  children: [
    {
      path: `/${subDomain}`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={RocketLandingPage}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/liveboardmanager`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <AppEmbedWrapper
              cssRules={appEmbedWrapperCssRules}
              breakPoint={DefaultSidebarBreakpoint}
              showPrimaryNavbar={true}
              disableProfileAndHelp={true}
              className="ts-full-app h-100"
              orgObject={rocketObject}
            />
          }
          groups={[]}
        />
      ),
    },
    {
      path: `/${subDomain}/ceosummary`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <GenericLiveboardEmbed
              enablePremiumFeatures={false}
              description="CEO Summary"
              guid="dc9fe8a3-cdbd-4a72-a0d7-2fb0eb1eb045"
              orgID={orgId}
            />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/cfosummary`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <GenericLiveboardEmbed
              enablePremiumFeatures={false}
              description="CFO Summary"
              guid="afb363b8-7adc-4fb2-972b-3331c686d878"
              orgID={orgId}
            />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/segmentanalytics`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <GenericLiveboardEmbed
              enablePremiumFeatures={false}
              description="Segment Analytics"
              guid="0c9e29f5-d22a-4480-b6e8-b3f38e01b3ce"
              orgID={orgId}
            />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/servicing`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <GenericLiveboardEmbed
              enablePremiumFeatures={false}
              description="Rocket Servicing Overview"
              guid="15d99cc5-4f08-4c2e-b0b4-a816e93f77e4"
              orgID={orgId}
            />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/search`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <GenericLiveboardEmbed
              enablePremiumFeatures={false}
              description="Search"
              guid=""
              orgID={orgId}
              search={{
                enableSearch: true,
                searchDataSource: [
                  "d7cc62fd-8881-4ac9-83a0-b1236721b32d",
                  "733e6ead-666a-4429-8f51-f04e3da69e05",
                  "73556010-c9ee-4ef6-bac7-2756bac0944c",
                  "15a1ee2a-f19e-430f-9db0-98b987ae0f63",
                  "d724fc06-fd86-40ee-86f4-81b9f1d2ae55",
                  "d2efaaa2-e91e-466a-b766-e4b17422f8c3",
                  "bbcd7477-c52b-4f8c-ab18-1b10db4c7dac",
                  "9f33e000-a7e9-4c87-aa50-141ce9ea25f1",
                  "ae892e7a-b477-4b1d-b2a9-3d499903ea05",
                  "339ad157-b865-499f-8b90-442d3bbc79d6",
                ],
              }}
            />
          }
          groups={[]}
        />
      ),
    },
    {
      path: `/${subDomain}/contactus`,
      element: <ContactUs />,
    },
    {
      path: `/${subDomain}/incomestatement`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<RocketIncomeStatement />}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/balancesheet`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<RocketBalanceSheet />}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/cashflowwalk`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<CashFlowWalk />}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/profitabilitywalk`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<ProfitabilityWalk />}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/financialmodeling`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<FinancialModeling />}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/signout`,
      element: <SignOut />,
    },
  ],
};
